import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import Scrollbar from 'libs/Scrollbar';
import { DetailTemplate } from 'components';
import * as common from 'libs/commonFunc';

import styles from './Edu.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class EduTargetDetail extends Component {
  checkTargetValue = name => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { eduTargetDataByTargetNo, selectEduTargetNo, selectEduNo, eduSummaryByEduNo } = this.props;
    const target = eduTargetDataByTargetNo.get(String(selectEduTargetNo)).toJS();

    if (target && (target[name] || target[name] === 0)) {
      if (name === 'send' || name === 'read') {
        return common.timeFormatFromUTCEpoch(target[name]);
      } else if (name === 'eduStatus') {
        if (target[name] === 1) {
          return defineMessages(formatMessage({ id: 'Edu_14', defaultMessage: '진행중' }));
        } else if (target[name] === 2) {
          return defineMessages(formatMessage({ id: 'Edu_15', defaultMessage: '완료' }));
        } else {
          return defineMessages(formatMessage({ id: 'Edu_16', defaultMessage: '진행전' }));
        }
      } else if (name === 'quizSolutionData') {
        const summaryInfo = eduSummaryByEduNo.get(String(selectEduNo)).toJS();
        const quizData = summaryInfo && summaryInfo.quizData;
        const resultComponent = [];
        if (!!quizData && quizData.length > 0) {
          quizData.map((quiz, index) => {
            const solutionData = target[name][quiz.quizNo];
            resultComponent.push(
              <tr key={index} className={cx('quiz-table-body')}>
                <td className={cx('quiz-content')}>{quiz.quizContent}</td>
                <td className={cx('quiz-solution')}>
                  {solutionData ? (solutionData.quizSolution === 1 ? '정답' : '오답') : '미제출'}
                </td>
              </tr>
            );
          });
        }
        return resultComponent;
      } else {
        return target[name];
      }
    } else {
      return '-';
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { checkTargetValue } = this;
    const { onMoveScroll, onToggleDetailView, onRefRegister, eduSummaryByEduNo, selectEduNo } = this.props;

    const summaryInfo = eduSummaryByEduNo.get(String(selectEduNo)).toJS();
    const quizData = summaryInfo && summaryInfo.quizData;

    return (
      <DetailTemplate onMoveScroll={onMoveScroll} onToggleDetailView={onToggleDetailView}>
        <Scrollbar
          ref={Scroll => {
            onRefRegister('scroll', Scroll);
          }}>
          <div className={cx('element-wrapper', 'edu-detail-wrapper')}>
            {/* 대상자 교육 결과 */}
            <div className={cx('element')}>
              <div className={cx('segment-title')}>
                <span className={cx('toggle-title bold')}>
                  {defineMessages(formatMessage({ id: 'Edu_59', defaultMessage: '대상자 교육 결과' }))}
                </span>
              </div>
              <div className={cx('segment-content')}>
                <div className={cx('targetStatus')}>
                  <div className={cx('targetStatus-title')}>
                    {defineMessages(formatMessage({ id: 'ExamDetailPi_10', defaultMessage: '대상자 번호' }))}
                  </div>
                  <div className={cx('targetStatus-content')}>{checkTargetValue('targetNo')}</div>
                </div>
                <div className={cx('targetStatus')}>
                  <div className={cx('targetStatus-title')}>
                    {defineMessages(formatMessage({ id: 'ExamDetailPi_11', defaultMessage: '대상자 이름' }))}
                  </div>
                  <div className={cx('targetStatus-content')}>{checkTargetValue('targetName')}</div>
                </div>
                <div className={cx('targetStatus')}>
                  <div className={cx('targetStatus-title')}>
                    {defineMessages(formatMessage({ id: 'ExamDetailPi_12', defaultMessage: '대상자 메일' }))}
                  </div>
                  <div className={cx('targetStatus-content')}>{checkTargetValue('targetEmail')}</div>
                </div>
                <div className={cx('targetStatus')}>
                  <div className={cx('targetStatus-title')}>
                    {defineMessages(formatMessage({ id: 'ExamDetailPi_14', defaultMessage: '대상자 소속' }))}
                  </div>
                  <div className={cx('targetStatus-content')}>{checkTargetValue('targetDivision')}</div>
                </div>
                <div className={cx('targetStatus')}>
                  <div className={cx('targetStatus-title')}>
                    {defineMessages(formatMessage({ id: 'ExamDetailPi_15', defaultMessage: '대상자 직급' }))}
                  </div>
                  <div className={cx('targetStatus-content')}>{checkTargetValue('targetPosition')}</div>
                </div>
                <div className={cx('targetStatus')}>
                  <div className={cx('targetStatus-title')}>
                    {defineMessages(formatMessage({ id: 'ExamDetailPi_18', defaultMessage: '발송' }))}
                  </div>
                  <div className={cx('targetStatus-content')}>{checkTargetValue('send')}</div>
                </div>
                <div className={cx('targetStatus')}>
                  <div className={cx('targetStatus-title')}>
                    {defineMessages(formatMessage({ id: 'ExamDetailPi_19', defaultMessage: '열람' }))}
                  </div>
                  <div className={cx('targetStatus-content')}>{checkTargetValue('read')}</div>
                </div>
                <div className={cx('targetStatus')}>
                  <div className={cx('targetStatus-title')}>
                    {defineMessages(formatMessage({ id: 'Edu_46', defaultMessage: '교육현황' }))}
                  </div>
                  <div className={cx('targetStatus-content')}>{checkTargetValue('eduStatus')}</div>
                </div>
              </div>
            </div>

            {/* 대상자 퀴즈 결과 */}
            <div className={cx('element')}>
              <div className={cx('segment-title')}>
                <span className={cx('toggle-title bold')}>
                  {defineMessages(formatMessage({ id: 'Edu_60', defaultMessage: '대상자 퀴즈 결과' }))}
                </span>
              </div>
              <div className={cx('segment-content')}>
                <table className={'quiz-table'}>
                  <tbody>
                    {checkTargetValue('quizSolutionData').length > 0 ?
                      (<tr className={'quiz-table-header'}>
                        <th>{defineMessages(formatMessage({ id: 'Quiz_2', defaultMessage: '퀴즈 내용' }))}</th>
                        <th>{defineMessages(formatMessage({ id: 'Quiz_12', defaultMessage: '정답 여부' }))}</th>
                      </tr>)
                      :
                      (<tr className={cx('no-result')}>
                        <td>{defineMessages(formatMessage({ id: 'Edu_61', defaultMessage: '퀴즈 결과가 없습니다.' }))}</td>
                      </tr>
                      )}
                    {checkTargetValue('quizSolutionData')}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Scrollbar>
      </DetailTemplate>
    );
  }
}

export default injectIntl(EduTargetDetail);


// WEBPACK FOOTER //
// ./src/script/components/edu/EduTargetDetail.js